import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Popup from 'reactjs-popup';
import { CSVReader } from 'react-papaparse';
import {
  sess_delete, sess_get, sess_post, sess_put,
} from 'utils/HttpRequests';
import { toast } from 'react-toastify';
import {
  faDownload,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CsvDownloader from 'react-csv-downloader';

export function AddBlackListNumbers(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [url, setURL] = useState('');
  const [website, setWebsite] = useState('');

  const handleOnDrop = (list) => {
    list = list.map((item) => item.data[0]);
    setNumbers(list);
  };

  const handleOnRemoveFile = () => {
    setNumbers([]);
  };

  const submitHandler = () => {
    sess_post('admin/console/black-list', localStorage.getItem('admin-panel-sessionToken'), { numbers, url, website })
      .then((res) => { setIsOpen(false); toast.success('Uploaded Successfully'); props.fetchData(); })
      .catch((err) => { console.log(err); toast.error('an error occured'); });
  };

  return (
    <div className="trusted-service-content">
      <Button
        variant="danger"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Add Numbers
      </Button>
      <Popup open={isOpen} closeOnDocumentClick={false} closeOnEscape={false}>
        <div style={{ padding: '16px' }}>
          <h3 style={{ textAlign: 'center' }}>Upload numbers list</h3>
          <hr />
          <div>Website Name</div>
          <input
            placeholder="website"
            style={{ marginBottom: '8px' }}
            value={website}
            onChange={(e) => { setWebsite(e.target.value); }}
          />
          <div>Website URL</div>
          <input
            placeholder="URL"
            style={{ marginBottom: '8px' }}
            value={url}
            onChange={(e) => { setURL(e.target.value); }}
          />
          <div>Upload numbers</div>
          <CSVReader
            onDrop={handleOnDrop}
            // onError={this.handleOnError}
            addRemoveButton
            removeButtonColor="#659cef"
            onRemoveFile={handleOnRemoveFile}
          >
            <span>Drop CSV file here or click to upload.</span>
          </CSVReader>
          <div style={{ margin: '10px', display: 'flex', justifyContent: 'space-around' }}>
            <Button
              variant="danger"
              onClick={() => {
                submitHandler();
              }}
            >
              Add Numbers
            </Button>
            <Button onClick={() => setIsOpen(false)}>Close</Button>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default function BlackList() {
  const [data, setData] = useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState('');
  const [editPopupOpen, setEditPopupOpen] = useState('');
  const [numbers, setNumbers] = useState([]);

  const fetchData = () => {
    sess_get('admin/console/black-list', localStorage.getItem('admin-panel-sessionToken'))
      .then((res) => { setData(res?.data?.response?.list); })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleOnDrop = (list) => {
    list = list.map((item) => item.data[0]);
    setNumbers(list);
  };

  const handleOnRemoveFile = () => {
    setNumbers([]);
  };

  const editHandler = () => {
    sess_put('admin/console/black-list', localStorage.getItem('admin-panel-sessionToken'), { numbers, id: editPopupOpen })
      .then((res) => { setEditPopupOpen(''); toast.success('Numbers uploaded successfully'); fetchData(); })
      .catch((err) => { toast.error('an error occured'); });
  };

  const deleteHandler = () => {
    sess_delete('admin/console/black-list', localStorage.getItem('admin-panel-sessionToken'), { id: deletePopupOpen })
      .then((res) => { setDeletePopupOpen(''); toast.success('Deleted successfully'); fetchData(); })
      .catch((err) => { toast.error('an error occured'); });
  };

  let tableData;

  if (data.length > 0) {
    tableData = data.map((item) => (
      <tr style={{ height: '50px' }}>
        <td>{item.website || '-'}</td>
        <td><a href={item.url}>{item.url || '-'}</a></td>
        <td>
          <CsvDownloader
            filename={`${item.website
            }_${new Date().toLocaleDateString()}`}
            separator=","
            datas={
              item?.numbers?.length
                ? item?.numbers.map((detail) => ({
                  contact_nos: detail,
                }))
                : [{}]
            }
            // className="SearchButton BgGreen"
            text={item?.numbers?.length || 0}
          >
            <div>
              {item?.numbers?.length || 0}

              <FontAwesomeIcon
                icon={faDownload}
                style={{ width: '10%' }}
                onClick={(e) => {
                  e.preventDefault();
                }}
              />
            </div>
          </CsvDownloader>

        </td>
        <td>
          <FontAwesomeIcon
            style={{ margin: '0 10px', cursor: 'pointer' }}
            icon={faTrashAlt}
            onClick={(e) => {
              e.preventDefault();
              setDeletePopupOpen(item._id);
            }}
          />
          <FontAwesomeIcon
            style={{ margin: '0 10px', cursor: 'pointer' }}
            icon={faEdit}
            onClick={(e) => {
              e.preventDefault(item._id);
              setEditPopupOpen(item._id);
            }}
          />
        </td>
      </tr>
    ));
  }

  return (
    <div className="container">
      <h1 className="trusted-service-content">Black List</h1>
      <AddBlackListNumbers fetchData={fetchData} />
      <Popup open={deletePopupOpen !== ''} closeOnEscape={false} closeOnDocumentClick={false}>
        <div style={{ padding: '16px' }}>
          <h3 style={{ margin: '10px', textAlign: 'center' }}>
            Are you sure you want to delete list?
          </h3>
          <div style={{ margin: '10px', display: 'flex', justifyContent: 'space-around' }}>
            <Button onClick={deleteHandler}>Confirm</Button>
            <Button onClick={() => setDeletePopupOpen('')}>Close</Button>
          </div>
        </div>
      </Popup>
      <Popup open={editPopupOpen !== ''} closeOnEscape={false} closeOnDocumentClick={false}>
        <div style={{ padding: '16px' }}>
          <h3 style={{ margin: '10px', textAlign: 'center' }}>
            Add numbers to the list
          </h3>
          <CSVReader
            onDrop={handleOnDrop}
            // onError={this.handleOnError}
            addRemoveButton
            removeButtonColor="#659cef"
            onRemoveFile={handleOnRemoveFile}
          >
            <span>Drop CSV file here or click to upload.</span>
          </CSVReader>
          <div style={{ margin: '16px', display: 'flex', justifyContent: 'space-around' }}>
            <Button onClick={editHandler}>Confirm</Button>
            <Button onClick={() => setEditPopupOpen('')}>Close</Button>
          </div>
        </div>
      </Popup>
      <div className="trusted-service-table">
        <table>
          <thead>
            <tr>
              <th scope="col">
                <center>
                  <a style={{ color: '#337ab7' }}>Website</a>
                </center>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: '#337ab7' }}>URL</a>
                </center>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: '#337ab7' }}>Numbers Count</a>
                </center>
              </th>
              <th scope="col">
                <center>
                  <a style={{ color: '#337ab7' }}>Action</a>
                </center>
              </th>

            </tr>
          </thead>
          <tbody>
            {tableData}
          </tbody>
        </table>

      </div>
    </div>

  );
}
